<template>
  <div>
    <list
      row-key="UserId"
      ref="list"
      unit="记录"
      :expand-all-row="true"
      :page="page"
      :query-params="params"
      :show-checkbox="false"
      :show-query="showQuery"
      :get-data-func="api.list"
      :showReset="false"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="学期名称">
          <el-select v-model="params.TermId" @change="termChange" size="mini">
            <el-option
              v-for="item in termList"
              :key="item.TermId"
              :value="item.TermId"
              :label="item.TermName"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="年级">
          <el-select v-model="params.Grade" size="mini" clearable>
            <el-option v-for="item in gradeList" :key="item.GradeId" :value="item.Grade"></el-option>
          </el-select>
          <!-- <el-input size="mini" v-model="params.Grade" placeholder="请填写年级" clearable /> -->
        </el-form-item>
        <el-form-item label="班级">
          <el-input size="mini" v-model="params.Class" placeholder="请填写班级" clearable />
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="Grade" label="年级" />
        <el-table-column prop="Class" label="班级" />
        <el-table-column prop="TermName" label="学期名称" min-width="140" />
        <slot name="column"></slot>
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
import termApi from "@/api/ed/term";

export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      api: require("@/api/ed/class").default,
      gradeApi: require("@/api/ed/grade").default,
      params: {
        Class: "",
        Grade: "",
        TermId: null,
      },
      termApi,
      termList: [],
      gradeList: [],
    };
  },
  beforeMount() {
    this.termApi.list().then((res) => {
      this.termList = res.Data || [];
      if (res.Data.length > 0) {
        this.params.TermId = res.Data[0].TermId;
        sessionStorage.setItem("termId", res.Data[0].TermId);
        sessionStorage.setItem("termName", res.Data[0].TermName);
        sessionStorage.setItem("termNumber", res.Data[0].TermNumber);
        this.query({ TermId: res.Data[0].TermId });
      }
    });
  },
  mounted() {
    this.getGrade();
  },
  methods: {
    getGrade() {
      this.gradeApi.list().then((res) => {
        this.gradeList = res.Data;
      });
    },
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error("删除失败，" + res.Msg);
        }
      });
    },
    termChange(e) {
      sessionStorage.setItem("termId", e);
      let t = this.termList.find((x) => {
        if (e == x.TermId) {
          return x;
        }
      });
      sessionStorage.setItem("termName", t.TermName);
      this.query({
        TermId: e,
        Grade: this.params.Grade,
        Class: this.params.Class,
      });
    },
  },
};
</script>